export const defaultColors = [
    ['linear-gradient(180deg, #E5F9FB 0%, #AB91CD 100%)', '#F8EFFF', '#D0B7E2', '#AA77CE', '#4D3D5C'],
    ['linear-gradient(180deg, #FFC2AE 0%, #AB91CD 100%)', '#FDF0F5', '#E772A1', '#E24D84', '#8F1943'],
    ['linear-gradient(180deg, #FAD4B1 0%, #F37E8C 100%)', '#FDE7DD', '#EE948A', '#E3645D', '#871212'],
    ['linear-gradient(180deg, #B9DCF2 0%, #F6CFBE 100%)', '#FDEDDF', '#FAD4B1', '#F5982B', '#AB4205'],
    ['linear-gradient(180deg, #E9B7CE 0%, #CEE1E0 100%)', '#FEF9E6', '#FFE380', '#FFCA42', '#E19800'],
    ['linear-gradient(180deg, #FADDB1 0%, #A1DEC1 100%)', '#F1FAF6', '#A1DEC1', '#43BF8B', '#2C5140'],
    ['linear-gradient(180deg, #FFEBC6 0%, #96D3D7 100%)', '#F6FBFC', '#96D3D7', '#5CBFCC', '#28545E'],
    ['linear-gradient(180deg, #96D3D7 0%, #7F98F0 100%)', '#F1F4FE', '#3A64F7', '#4D71ED', '#111E49'],
    ['linear-gradient(180deg, #F1E1C2 0%, #FCBC98 100%)', '#F9F8F7', '#F7F0EA', '#D6CFC9', '#9B9288'],
    ['linear-gradient(180deg, #E3ECED 0%, #B5C6E0 100%)', '#FFFFFF', '#F8F8F9', '#636363', '#000000'],
];
